import { ResolvedRoutesConfig, ResolvedUrlRoute } from "single-spa-layout/dist/types/isomorphic/constructRoutes";
import { isRoutePublic } from "./publicRoutes";
import { DRSRoute } from "../types/drs";

export const isCurrentRouteAvailable = (routes: ResolvedUrlRoute[]) => {
  const currentPathname = window.location.pathname;
  return routes.some((route) => {
    if (route.exact) {
      return currentPathname === route.path;
    }
    return currentPathname.startsWith(`${route.path}/`) || currentPathname === route.path;
  });
};

export const checkUserLaunchPoint = (routing: ResolvedRoutesConfig, drsRoutes: DRSRoute[]) => {
  const routes = routing.routes as ResolvedUrlRoute[];
  const routeExists = isCurrentRouteAvailable(routes);

  if (routeExists || isRoutePublic()) return;

  for (const drsRoute of drsRoutes) {
    if (!("launch_point" in drsRoute) || !drsRoute.attached_to_menu) continue;

    history.pushState({}, "", drsRoute.launch_point);
    return;
  }
};
